export default {
  title: "My POAPs",
  empty: {
    titleLead: "Your wallet is empty.",
    titleEmphasis: "For now.",
    description: "The POAPs you mint will show up here, verifiable on-chain. Start with the collection.",
    button: "Explore POAPs",
  },
}
